import { render } from "./AiUsageDashboard.vue?vue&type=template&id=2bbf7a6a&scoped=true"
import script from "./AiUsageDashboard.vue?vue&type=script&lang=js"
export * from "./AiUsageDashboard.vue?vue&type=script&lang=js"

import "./AiUsageDashboard.vue?vue&type=style&index=0&id=2bbf7a6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbf7a6a"]])

export default __exports__